import React from "react";
import ReactDOM from "react-dom";
import { Helmet } from "react-helmet";
import App from "./app/App";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <React.StrictMode>
    <Helmet>
      <meta
        name="robots"
        content={
          process.env.REACT_APP_ENV === "production"
            ? "index,follow"
            : "noindex,nofollow"
        }
      />
    </Helmet>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
